import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { ToastContainer } from 'react-toastify';

import NavBar from '../../components/NavBar';
import { Footer } from '../../components/Footer/Footer';

import { HeaderSection } from './HeaderSection';
import { PlatformSection } from './PlatformSection';
import { CashCleverWorks } from './CashCleverWorks';
import { EmpoweringLendersSection } from './EmpoweringLendersSection';

import { CompareResults } from '../../components/CompareResults';
import ToasterSurvey from '../../components/Elements/ToasterSurvey';
import { useToaster } from '../../components/Elements/useToaster';

import { useAuthentication } from '../../CustomHooks/useAuthentication';

import { TOKEN, LOGOUT, handleSettingsClick } from '../../constants';

import '../../App.css';

import './landing.css';

export const Landing = ({ logout }) => {
  const containerRef = useRef(null);
  const [userId, isLoggedIn] = useAuthentication();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (logout) {
      handleSettingsClick[LOGOUT]?.(dispatch, { id: userId });
      navigate('/');
      return;
    }
  }, [logout, dispatch, navigate]);

  //call toaster
  useToaster(containerRef, ToasterSurvey, 'survey-toast');

  return (
    <div>
      <div className="landing-wrapper landing-header-wrapper">
        <NavBar userId={userId} />
        <HeaderSection isLoggedIn={isLoggedIn} userId={userId} />
        <PlatformSection userId={userId} />
        <CashCleverWorks userId={userId} />
        <div ref={containerRef}> </div>
        {/* <ToastContainer userId={userId} /> */}
        <div className="landing-page-compare-results-wrapper">
          <CompareResults />
        </div>
        <EmpoweringLendersSection userId={userId} />
      </div>
      <Footer />
    </div>
  );
};
